interface Props {
  name: string
  /** Optional uploaded avatar URL — when present, renders the photo
   *  instead of the coloured-initials tile. Falls through to initials
   *  on load failure (slow network, deleted file). */
  avatarUrl?: string | null
  size?: 'sm' | 'md' | 'lg' | 'xl'
  isAi?: boolean
  className?: string
}

const COLORS = [
  'bg-red-100 text-red-600',
  'bg-orange-100 text-orange-600',
  'bg-amber-100 text-amber-700',
  'bg-green-100 text-green-600',
  'bg-teal-100 text-teal-600',
  'bg-blue-100 text-blue-600',
  'bg-purple-100 text-purple-600',
  'bg-pink-100 text-pink-600',
]

function colorForName(name: string): string {
  const idx = name.charCodeAt(0) % COLORS.length
  return COLORS[idx]
}

const SIZES = {
  sm:  'w-8 h-8 text-xs',
  md:  'w-10 h-10 text-sm',
  lg:  'w-14 h-14 text-lg',
  xl:  'w-20 h-20 text-2xl',
}

import { useState } from 'react'

export function Avatar({
  name, avatarUrl, size = 'md', isAi = false, className = '',
}: Props) {
  const initials = name.slice(0, 2).toUpperCase()
  const colorClass = colorForName(name)
  const [imgFailed, setImgFailed] = useState(false)
  const showImage = avatarUrl && !imgFailed

  return (
    <div className={`relative inline-flex items-center justify-center rounded-full
                     overflow-hidden font-semibold ${SIZES[size]}
                     ${showImage ? 'bg-brand-elevated' : colorClass} ${className}`}>
      {showImage ? (
        <img
          src={avatarUrl!}
          alt={name}
          loading="lazy"
          draggable={false}
          onError={() => setImgFailed(true)}
          className="absolute inset-0 w-full h-full object-cover"
        />
      ) : (
        initials
      )}
      {isAi && (
        <span className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full
                         bg-purple-500 flex items-center justify-center text-[8px]">
          🤖
        </span>
      )}
    </div>
  )
}
